import { api } from '@/lib/api'
import type { FiscalYearsResponse, YearEndClosePreview } from './types'

const BASE = '/api/reporting'

export const yearEndCloseApi = {
  fiscalYears: () => api.get<FiscalYearsResponse>(`${BASE}/fiscal-years`),
  preview: (year: number, fiscalStartMonth: number) =>
    api.get<YearEndClosePreview>(`${BASE}/year-end-close/${year}/preview`, {
      query: { fiscalStartMonth },
    }),
  close: (fiscalYear: number, fiscalStartMonth: number) =>
    api.post<{ message?: string }>(`${BASE}/year-end-close`, { fiscalYear, fiscalStartMonth }),
  reverse: (year: number, fiscalStartMonth: number) =>
    api.post<{ message?: string }>(`${BASE}/year-end-close/${year}/reverse`, {
      fiscalStartMonth,
    }),
}
